import React from "react";

function Icon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      clipRule="evenodd"
      viewBox="0 0 270 270"
      width={props.width}
      className={props.svgClass}
    >
      <g transform="matrix(.65811 0 0 .76738 -6277.22 -1374.53)">
        <path
          fill="none"
          d="M9538.22 1791.21H9948.483999999999V2143.059H9538.22z"
        ></path>
        <clipPath id="clip_mailOpen">
          <path d="M9538.22 1791.21H9948.483999999999V2143.059H9538.22z" fill="red"></path>
        </clipPath>
        <g clipPath="url(#clip_mailOpen)">
          <path
            className={props.pathClass}
            d="M11851.5 2025.93c0-1.03.4-2 1.2-2.65 12.1-9.75 107.3-86.45 129.4-104.26 2.6-2.14 6.4-2.14 9.1.01 22 17.8 117 94.44 129.1 104.24.9.65 1.3 1.63 1.3 2.67v151.32c0 4.02-3.2 7.28-7.2 7.28h-255.7c-4 0-7.2-3.26-7.2-7.28v-151.33zm14.5 144.02h3.7l71-57.3-74.7-60.26v117.56zm64.9 0h-38l62.5-50.43h62.4l62.5 50.43h-149.4zm101.7-57.3l71 57.3h3.4v-117.42l-74.4 60.12zm-168-80.12l122-98.45 122 98.45-89.7 72.4h-64.5l-89.8-72.4z"
            transform="matrix(1.5195 0 0 1.30314 -8470.29 -703.705)"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
